import { footerChunks } from "@/mocks/freegua";

export default function Footer() {
  return (
    <footer>
      {/* CTA */}
      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 pb-4 md:px-6">
          <div className="relative overflow-hidden rounded-3xl bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
            <div className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full bg-background-50/15 blur-2xl" />
            <div className="pointer-events-none absolute -bottom-14 -right-8 h-52 w-52 rounded-full bg-accent-500/40 blur-2xl" />
            <div className="relative mx-auto max-w-2xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-sm font-bold text-background-50">
                <i className="ri-water-flash-line" aria-hidden="true" />
                免费吃瓜无门槛 · 零元看
              </span>
              <h2 className="mt-5 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
                这一则瓜，现在就能直接看
              </h2>
              <p className="mt-4 text-base leading-relaxed text-background-50/90">
                不用付费也不用开会员，不注册、不收藏，点开就是免费吃瓜。整理好的截图、时间线与后续回应，此刻都在等你。
              </p>
              <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href="#today"
                  className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-7 py-3.5 text-base font-bold text-primary-700 hover:bg-background-100 sm:w-auto"
                >
                  <i className="ri-eye-line mr-2" aria-hidden="true" />
                  免费吃瓜直接看
                </a>
                <a
                  href="#top"
                  className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-background-50/50 px-7 py-3.5 text-base font-bold text-background-50 hover:bg-background-50/10 sm:w-auto"
                >
                  回到顶部
                  <i className="ri-arrow-up-line ml-2" aria-hidden="true" />
                </a>
              </div>
              <p className="mt-6 text-xs text-background-50/70">
                本站为素材整理与围观指引展示页，所列瓜名与情节均为占位示例。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* footer body */}
      <div className="bg-secondary-50">
        <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
          <div className="grid gap-10 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                  <i className="ri-water-flash-line text-lg" aria-hidden="true" />
                </span>
                <span className="font-label text-lg font-extrabold text-foreground-950">免费吃瓜</span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
                免费吃瓜零元看所有热门素材，截图、时间线、后续回应整理成线。免费吃瓜无门槛、不设会员，点开就有的看。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {["免费吃瓜直接看", "零元直接看", "不设会员"].map((t) => (
                  <span
                    key={t}
                    className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs font-bold text-secondary-800"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>

            {footerChunks.map((c) => (
              <div key={c.head} className="lg:col-span-2">
                <h3 className="font-label text-sm font-extrabold text-foreground-950">{c.head}</h3>
                <ul className="mt-4 space-y-2.5">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="whitespace-nowrap text-sm text-foreground-600 hover:text-primary-700">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="lg:col-span-1" />
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
            <p className="text-xs text-foreground-500">
              © 2026 免费吃瓜 · 本页内容为单页静态展示，仅供浏览。
            </p>
            <p className="flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-accent-600" aria-hidden="true" />
              免费吃瓜不付费 · 不注册 · 零元看
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}